import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

/**
 * Globálny tracker klikov používateľov (issue #415).
 *
 * Mountuje sa raz na prihlásenej stránke a cez delegovaný click listener na `document`
 * odchytáva kliky na ľubovoľný prvok (alebo jeho predka) označený atribútom `data-track-id`.
 * Pre každý taký klik pošle fire-and-forget POST na backend endpoint.
 *
 * Sledovaný prvok musí niesť:
 *   - data-track-id    povinné, identifikátor elementu (napr. "menu.summary", "box.benefit")
 *   - data-track-name  voliteľné, ľudský názov; fallback = textContent prvku
 *   - data-track-label voliteľné, doplnková hodnota (napr. cieľová URL)
 */

const ENDPOINT = '/api/securedBySession/clickTracking/record';
const SELECTOR = '[data-track-id]';

class ClickTracker extends WebComponent {

	didMount() {
		this.handleClick = this.handleClick.bind(this);
		document.addEventListener('click', this.handleClick, true);
	}

	willUnMount() {
		document.removeEventListener('click', this.handleClick, true);
	}

	handleClick(e) {
		const el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
		if (!el) {
			return;
		}
		const elementId = (el.getAttribute('data-track-id') || '').trim();
		const elementName = (el.getAttribute('data-track-name') || el.textContent || '').trim();
		if (!elementId || !elementName) {
			return;
		}
		const label = (el.getAttribute('data-track-label') || '').trim();
		const body = { elementId, elementName };
		if (label) {
			body.label = label;
		}
		try {
			fetch(ENDPOINT, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'same-origin',
				keepalive: true, // odošle sa aj keď klik na odkaz okamžite naviguje preč
				body: JSON.stringify(body),
			}).catch(() => {}); // nikdy neblokovať / nezhadzovať preklik
		} catch (ignored) {
			// fetch nemusí byť dostupný v starších prehliadačoch – tracking je best-effort
		}
	}
}

export default ClickTracker;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/ClickTracker.js